import styled from '@emotion/styled'
export const styleRowWrapper = `
  @media(max-width:767px){
    flex-flow:row wrap;
  }
`
export const StyleLeftBannerForm = styled.div`
  width: 48%;
  display: flex;
  flex-direction: column;
  row-gap: 15px;
  @media (max-width: 767px) {
    width: 100%;
  }
`
export const StyleRightBannerForm = styled.div`
  width: 48%;
  @media (max-width: 767px) {
    width: 100%;
    margin-top: 15px;
  }
`
